'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require('../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _FormButton = require('../../../components/form/FormButton');

var _FormButton2 = _interopRequireDefault(_FormButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnsubscribeProcessing = function UnsubscribeProcessing(_ref) {
    var onErrorButtonClick = _ref.onErrorButtonClick;
    return _react2.default.createElement(
        'div',
        { className: 'Form UnsubscribeProcessing modal-flex' },
        _react2.default.createElement(
            'div',
            { className: 'content' },
            _react2.default.createElement(_Icon2.default, { name: 'error-alert' }),
            _react2.default.createElement(
                'h1',
                null,
                'Sorry, something went wrong!'
            ),
            _react2.default.createElement(
                'p',
                null,
                'Please ',
                _react2.default.createElement(
                    'a',
                    { href: 'mailto:support@milanote.com' },
                    'contact us'
                ),
                ' or try again'
            ),
            _react2.default.createElement(
                _FormButton2.default,
                { className: 'primary', onClickFn: onErrorButtonClick },
                'Back'
            )
        )
    );
};

UnsubscribeProcessing.propTypes = {
    onErrorButtonClick: _propTypes2.default.func
};

exports.default = UnsubscribeProcessing;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/unsubscribe/UnsubscribeError.js
// module id = 2100
// module chunks = 0